import { Trash2, MapPinned, CalendarDays } from "lucide-react";
import { CountryPicker } from "./CountryPicker";
import { TripsDialog } from "./TripsDialog";
import { slug, prettyDate } from "@/lib/geo";

export const BeenThere = ({ visited, names, b, onFocus }) => (
  <div data-testid="been-there-section">
    <div className="flex items-center justify-between mb-4">
      <p className="text-sm text-slate-400">{b.readOnly ? "Countries explored so far." : "Pick a country, then tap its cities on the map."}</p>
      {!b.readOnly && <CountryPicker names={names} exclude={visited.map((v) => v.country)} onPick={b.toggleCountry} label="Add" testId="add-visited-country-button"
        className="bg-emerald-500 text-[#04120c] hover:bg-emerald-400" />}
    </div>
    {visited.length === 0 && <Empty />}
    <ul className="space-y-2">
      {visited.map((v) => (
        <li key={v.id} className="group rounded-xl border border-white/5 bg-white/[0.02] p-3 hover:border-emerald-500/30 transition-colors duration-200" data-testid={`visited-item-${slug(v.country)}`}>
          <div className="flex items-center justify-between gap-2">
            <button onClick={() => onFocus(v.country)} className="flex items-center gap-2 font-medium hover:text-emerald-300 transition-colors" data-testid={`visited-focus-${slug(v.country)}`}>
              <span className="w-2 h-2 rounded-full bg-emerald-400" /> {v.country}
            </button>
            <div className="flex items-center gap-3">
              <span className="font-mono text-[11px] text-slate-500">{v.cities.length} {v.cities.length === 1 ? "city" : "cities"}</span>
              {!b.readOnly && <>
                <TripsDialog v={v} b={b} testId={`trips-dialog-${slug(v.country)}`}>
                  <button className="text-slate-500 hover:text-emerald-300 transition-colors" data-testid={`visited-dates-${slug(v.country)}`} aria-label="Visit dates" title="Visit dates"><CalendarDays size={14} /></button>
                </TripsDialog>
                <button onClick={() => b.toggleCountry(v.country)} className="text-slate-500 hover:text-red-400 opacity-60 group-hover:opacity-100 transition" data-testid={`visited-delete-${slug(v.country)}`} aria-label="Remove"><Trash2 size={14} /></button>
              </>}
            </div>
          </div>
          {v.trips?.length > 0 && (
            <p className="font-mono text-[10px] text-emerald-300/70 mt-1.5 pl-4" data-testid={`visited-trips-${slug(v.country)}`}>
              {v.trips.map((t) => prettyDate(t.date, "MMM yyyy")).join(" · ")}
            </p>
          )}
          {v.cities.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-2 pl-4">
              {v.cities.map((c) => (
                <button key={c} disabled={b.readOnly} onClick={() => b.toggleCity(v.country, c)} title={b.readOnly ? c : "Click to remove"} data-testid={`visited-city-${slug(v.country)}-${slug(c)}`}
                  className={`text-[11px] px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-300 transition-colors ${b.readOnly ? "" : "hover:bg-red-500/15 hover:text-red-300"}`}>
                  {c}
                </button>
              ))}
            </div>
          )}
        </li>
      ))}
    </ul>
  </div>
);

const Empty = () => (
  <div className="text-center py-10 text-slate-500 text-sm" data-testid="visited-empty">
    <MapPinned className="mx-auto mb-2 opacity-50" /> Click a country on the map to start your story.
  </div>
);
